import * as React from 'react';
import { observer } from 'mobx-react';
import './userForm.module.scss';
import { UserFormState } from './states/UserFormState';
import { UserInfoInputItem } from './UserInfoInputItem';

type Props = {
  state: UserFormState;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children?: any;
};

export const UserForm = observer(
  class UserForm extends React.Component {
    props: Props;

    render() {
      const { state, children } = this.props;
      return (
        <div styleName="user-form" id="user-form">
          {state.fieldSpecs.map((spec) => {
            return (
              <UserInfoInputItem
                key={spec.key}
                name={spec.key}
                value={state.getValue(spec.key)}
                error={state.getError(spec.key)}
                placeholder={spec.placeholder}
                type={spec.type}
                onChange={(newValue) => state.setValue(spec.key, newValue)}
              />
            );
          })}
          {children}
        </div>
      );
    }
  }
);
